import React, { useEffect } from 'react'
import Customer from '../components/Customer'
import AmritjalFooter from '../components/Amritjal_hp/AmritjalFooter'
import PBoxHero from '../components/PrasadBox/PBoxHero'
import { useParams } from 'react-router-dom'
import PBBenefits from '../components/PrasadBox/PBBenefits'
import PBContent from '../components/PrasadBox/PBContent'
import PBContentVrindavan from '../components/PrasadBox/PBContentVrindavan'
import OfferCard from '../components/AmritjalProductDetail/AmritjalSpray/OfferCard'
import NavBar from '../components/Navbar'

const PrasadBox = () => {
  const { productId } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0); // Ensure scrolling to the top happens immediately
  }, []);

  return (
    <div>
      <NavBar/>
      <PBoxHero productId={productId} />
      {productId === "ayodhya-prasad-box" ? (
        <PBContent productId={productId}/>
      ) : (
        <PBContentVrindavan />
      )}
      <PBBenefits productId={productId}/>
      <OfferCard productId={productId}/>
      <Customer reviewFile={productId === "ayodhya-prasad-box" ? "ayodhya_prasad_box_reviews.json" : "vrindavan_prasad_box_reviews.json"}/>
      <AmritjalFooter/>
    </div>
  )
}

export default PrasadBox
